<template>
  <div class="kpi-rank-detail-page">
    <!--空数据-->
    <!-- <div v-if="params.finished && params.list.length === 0" class="empty-data">
      <span>没有相关记录</span>
    </div> -->
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="brand_type === 'score' ? 3 : 2" @change="setType">
      <van-tab v-for="(title) in types" :key="title.title" :title="title.title" :name="title.name">
        <!--明细列表-->
        <van-list v-model="params.loading" :finished="params.finished" @load="getList" finished-text="— 暂无更多数据 —" v-if="typeIndex === 'one'">
          <div class="item bottom-line" v-for="(item, key) in list" :key="key">
            <div class="content">
              <div class="one-nowrap" v-if="brand_type=='hand_naam'">{{item.brandName}}</div>
              <div class="one-nowrap" v-else>{{item.userName}}</div>
              <div v-if="item.status=='true'&&(brand_type=='hand_naam'||(brand_type=='score'&&item.userTagDTOs&&item.userTagDTOs.length))" class="do">{{item.amount}}</div>
              <div v-if="item.status=='true'&&(brand_type!='hand_naam'||(brand_type=='score'&&!item.userTagDTOs&&!item.userTagDTOs.length))" class="blue">{{item.amount?('+'+item.amount):'+1'}}</div>
              <div v-else>0</div>
            </div>
            <div class="content time">
              <div>{{item.happenTime}}</div>
            </div>
            <div v-if="brand_type=='hand_naam'" style="margin-top: 8px;color: red;">
              <div>处罚原因：{{item.remark}}</div>
            </div>
          </div>
        </van-list>
        <!-- 惩罚明细 -->
        <van-list v-model="params.loading" :finished="true" finished-text="— 暂无更多数据 —" v-if="typeIndex === 'two' &&brand_type=='score'">
          <div class="item bottom-line" v-for="(item, key) in punishList" :key="key">
            <div class="content">
              <div class="one-nowrap">惩罚原因：{{item.remark}}</div>
              <div class="do">{{item.amount}}</div>
            </div>
            <div class="content time">
              <div>{{item.happenTime}}</div>
            </div>
          </div>
        </van-list>
        <!-- 员工排行 -->
        <van-list v-model="params.loading" :finished="true" finished-text="— 暂无更多数据 —" v-if="typeIndex === 'three'">
          <div v-for="(item, key) in list" :key="key">
            <van-cell-group class="group">
              <van-cell :value="(item.score||0)" title-class="title" value-class="value">
                <template slot="title">
                  <span v-if="key === 0"><i class="icon icon-no1"></i></span>
                  <span v-if="key === 1"><i class="icon icon-no2"></i></span>
                  <span v-if="key === 2"><i class="icon icon-no3"></i></span>
                  <span v-if="key !== 0 && key !== 1 && key !== 2" class="no-num">{{item.rank}}</span>
                  <div class="img_box f fc fvc"><img :src="item.avatar ? item.avatar : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"/></div>
                  <span class="word">
                      <div class="name one-nowrap">{{item.name}}</div>
                    </span>
                </template>
              </van-cell>
            </van-cell-group>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>
  </div>
</template>

<script>
import backHome from '../../components/back-home.vue';

export default {
  components: {
    backHome
  },
  data() {
    return {
      load: true,//默认一开始不执行@load的方法
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      brand_id: this.$route.query.id,
      brand_type: this.$route.query.type,
      title: this.$route.query.title,
      start_time: this.$route.query.start_time,
      end_time: this.$route.query.end_time,
      typeIndex: 'one',
      types: [
        { title: `明细` }
      ],
      params: {
        loading: false,
        finished: false,
        index: 1,
        size: 50,
      },
      list: [],
      punishList: []
    };
  },
  created() {
    this.types= this.brand_type=='score'?[
      { title: `${this.title}明细`,name : 'one' },
      { title: `惩罚明细`, name: 'two' },
      { title: `员工排行`, name: 'three' }
    ]:[
      { title: `${this.title}明细`, name: 'one' },
      { title: `员工排行`, name: 'three' }
    ];
    this.getBrandDetailsList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    setType(){
      this.params.loading = false;
      this.params.finished = false;
      this.list = [];
      this.params.index = 1;
      if (this.typeIndex !=='three') {
        this.getBrandDetailsList();
      } else {
        this.getRankList()
      }
    },
    // 员工排行榜
    getRankList(){
      this.params.loading = true;
      this.$kpi.rank.getUserRankList({
        actId: Number(this.activity_id),
        brandId:Number(this.brand_id),
        kpi_userid: Number(localStorage.getItem('kpi_user_id')) || null,
        page: -1,
        size: -1,
        type: this.brand_type
      }).then((res) => {
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          console.log(res)
          var data=res.data;
          this.list = this.list.concat(data.list);
          let oTemp = null;
          let site = {logo:'https://j.weizan.cn/youxiang/icon.png',name:'优想互动'}||null;
          oTemp = this.$wm.set(80.2, this.list, site);
          document.getElementById('water-mark').appendChild(oTemp);
          this.params.finished = true;
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    // 排行榜明细
    getBrandDetailsList() {
      this.params.loading = true;
      this.$kpi.rank.getBrandDetails({
        actId: Number(this.activity_id),
        brandId: this.brand_id||null,
        page: this.params.index||1,
        size: this.params.size||1,
        startTime: this.start_time,
        endTime: this.end_time,
        type: this.brand_type,
      }).then(res=>{
        console.log(res)
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          var data=res.data;
          this.punishList = data.list&&data.list.length&&data.list[0].userTagDTOs||[];//积分的惩罚列表取数组里的第一条中的userTagDTOs
          if(data.list&&data.list.length==1&&!data.list[0].userName&&this.brand_type!='hand_naam'){//这里是处理如果只有一条数据时且数据里面没有信息的时候直接置空（第一条数据里面可能有惩罚列表userTagDTOs，但没有其他数据）
            data.list=[];
          }
          this.list = data.list||[];
          if(!data.list.length||data.list.length<this.params.size){
            this.params.finished=true;
          }
        }else if(res.code==10200){
          this.params.finished=true;
        }
      })
    },
    getList(){
      if(this.params.finished||this.load) return;
      ++this.params.index;
      this.getBrandDetailsList();
    },
  }
};

</script>

<style lang="less" scoped>
.kpi-rank-detail-page {
  position: relative;
  padding-bottom: 20px;
  height: 100vh;
  .tip {
    background-color: #ffffff;
    padding: 12px 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .item {
    background-color: #ffffff;
    padding: 10px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .time {
      color: #999999;
      font-size: 12px;
      margin-top: 8px;
    }
  }
}
.group {
  .value {
    color: #323232;
  }
  .van-cell {
    height: 80px;
  }
  .title {
    position: relative;
    z-index: 9;
    display: flex;
    align-items: center;
    min-width: 74%;
    max-width: 74%;
    .no-num {
      border: 2px solid #aedaff;
      box-sizing: border-box;
      background-color: #1986ff;
      color: #ffffff;
      text-align: center;
      width: 28px;
      max-width: 28px;
      min-width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 3px;
    }
    .img_box {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      margin: 0 5px;
      overflow: hidden;
      img{
        height: 100%;
      }
    }
    .word {
      position: relative;
      width: 66%;
      display: flex;
      flex-direction: column;
      .one-nowrap {
        height: 18px;
        line-height: 18px;
      }
      .store-name {
        font-size: 12px;
      }
      .progress {/*进度条*/
        position: relative;
        left: -4px;
        top: 2px;
        background-color: #eeeeee;
        width: 100%;
        height: 6px;
        margin: 0px 10px 0px 5px;
        border-radius: 4px;
        box-sizing: border-box;
        span {
          // width: 100%;
          position: absolute;
          left: 0px;
          background-color: #3283fa;
          height: 6px;
          border-radius: 4px;
        }
      }
    }
  }

  /deep/.van-cell {
    align-items: center;
  }
  /deep/.van-cell:not(:last-child)::after {
    left: 0;
  }

  i {display: block;position: relative;width: 30px;height: 30px;margin: 0 auto;}
  .icon-no1 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -5px -3px;background-size: 140px 38px;}
  .icon-no2 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -53px -3px;background-size: 140px 38px;}
  .icon-no3 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -106px -3px;background-size: 140px 38px;}
}

</style>
